import { useQuery } from '@tanstack/react-query';

import { sdk } from '@/services';

const UserInfoService = sdk.getService('UserInfoService');

export const useUserInfoByUser = (userId: string) => {
  const queryKey = ['profile', 'user-info', userId];

  const { data, isPending } = useQuery({
    queryKey,
    queryFn: () => UserInfoService.getUserInfoById(userId),
    enabled: !!userId
  });

  return { userInfo: data, isPending };
};
